import React from 'react'

const Experience = () => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
            <div className="resume-title border-line-h">
                <div className="icon"><i className="fa fa-briefcase"></i></div>
                <div className="name">Experience</div>
            </div>
            <div className="resume-items">
                <div className="resume-item border-line-h active">
                    <div className="date">April, 2018 - Present</div>
                    <div className="name">Technical Lead</div>
                    <div className="company">Robert Bosch Ltd</div>
                    <p>
                        Directed a 7-person team of personnel specializing in executing planned technical updates.<br/>
                        Helped to successfully migrating traditional legacy applications from Asp.Net to .Net Core and using Devops to deploy that sites on Azure.<br />
                        Leveraged Agile methodologies to move development lifecycle rapidly through initial prototyping to enterprise-quality testing and final implementation.
                    </p>
                </div>
                <div className="resume-item border-line-h">
                    <div className="date">Jan, 2016 - April, 2018</div>
                    <div className="name">Senior Software Engineer</div>
                    <div className="company">Infosys Ltd</div>
                    <p>
                        Helped in developing Universal Testing framework for automation testing using C# and Selenium which helped in Unit Testing.<br/>
                        Succefully implemeted the dashboard to display charts and help in displaying the Customer Relationship Insight's
                    </p>
                </div>
                <div className="resume-item">
                    <div className="date">August, 2013 - December, 2010</div>
                    <div className="name">Software Engineer</div>
                    <div className="company">Datamatics Global Services Ltd</div>
                    <p>
                        Successfully redesigned new IML website that should access all documents from new SharePoint 2013 repository instead of FileNet.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Experience;